import { useTranslation } from "react-i18next";
import { BaseButton } from "src/components";

type Props = {
  handleClickPayment: () => void;
};

const PaymentInfo = ({ handleClickPayment }: Props) => {
  const { t } = useTranslation("contract");
  return (
    <section className="base-section-layout">
      <div className="base-section-layout__container">
        <div className="base-section-layout__wrap">
          <div className="base-section-layout__title-wrap">
            <div className="w-100 text-center">
              <h2>{t("detail.registerPaymentMethod")}</h2>
              <p className="font14 mt10 text-primary3">{t("detail.registerOnceNotice")}</p>
            </div>
          </div>

          <div className="base-section-layout-index d-flex">
            <div className="w-100">
              <BaseButton title={t("detail.registerCreditCard")} className="base-btn size-small " onClick={handleClickPayment} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentInfo;
